// ** Initial State
const initialState = {
  productCategoryList: [],
  hgrkProductCategoryList: [],
  total: 1,
  params: {}
}

const categories = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CATEGORY_LIST':
      return { ...state, 
              productCategoryList: action.data.productCategoryList,
              hgrkProductCategoryList: action.data.hgrkProductCategoryList
              }
    case 'INSERT_CATEGORY':
      return {
        ...state,
        data: action.data
        // total: action.totalPages,
        // params: action.params
      }
    default:
      return { ...state }
  }
}
export default categories
